<template>
  <div>
    <v-dialog v-model="showUploadDialog" width="55%">
      <v-card>
        <v-toolbar dark color="secondary" max-height="64px">
          <v-card-title>{{ name }}</v-card-title>
          <v-spacer />
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <button
                type="button"
                class="btn btn-light btn-elevate-hover btn-circle btn-icon btn-sm mr-2"
                v-bind="attrs"
                v-on="on"
                dark
              >
                <i class="fas fa-question" />
              </button>
            </template>
            <span>Upload via local computer, file manager or url.</span>
          </v-tooltip>
          <button
            type="button"
            class="btn btn-light btn-elevate-hover btn-circle btn-icon btn-sm"
            :disabled="isLoading"
            @click="close"
          >
            <i class="fas fa-times" />
          </button>
        </v-toolbar>
        <v-container class="pa-5">
          <v-tabs vertical>
            <v-tab @change="changeTab('upload')">
              <v-icon left> mdi-account </v-icon>
              Local
            </v-tab>
            <v-tab @change="changeTab('filemanager')">
              <v-icon left> mdi-lock </v-icon>
              File Manager
            </v-tab>
            <v-tab @change="changeTab('url')">
              <v-icon left> mdi-access-point </v-icon>
              Via URL
            </v-tab>

            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-file-input
                    v-model="fileUpload"
                    v-validate="'required'"
                    :accept="checkFileType"
                    label="File"
                    placeholder="Upload"
                  >
                  </v-file-input>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text class="text-center" v-if="isLoading">
                  Fetching Data
                </v-card-text>
                <v-card-text v-if="files.length > 0">
                  <v-list-item-group
                    style="max-height: 200px; overflow-y: auto"
                    v-model="fileManager"
                  >
                    <v-list-item
                      v-for="(file, index) in files"
                      :key="index"
                      @change="changeSelected(file)"
                    >
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox
                            :input-value="active"
                            color="primary"
                          ></v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-img
                            v-if="file.type == 'image'"
                            v-model="url"
                            max-height="150"
                            max-width="150"
                            :src="file.url"
                          ></v-img>
                          <v-list-item-title v-else>
                            {{ file.name }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </v-list-item-group>
                </v-card-text>
                <v-card-text class="text-center" v-else>
                  No Files Found
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-text-field
                    v-model="url"
                    label="URL"
                    v-validate="'url'"
                    name="url"
                  />
                  <span
                    class="kt-font-danger validate-error"
                    v-show="errors.has('url')"
                    >Not a valid URL</span
                  >
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-container>
        <v-card-actions>
          <v-spacer />

          <v-btn
            color="blue-grey darken-1"
            text
            :disabled="isLoading"
            :loading="isLoading"
            @click="close"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="isLoading"
            :loading="isLoading"
            text
            @click="store"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'UploadFileDialog',
  data() {
    return {
      fileTypes: {
        all: '*/*',
        image: 'image/*',
        video: 'video/*',
        media: 'video/*,image/*',
      },
      currentFileType: null,
      uploadFileDialog: false,
      files: [],
      url: '',
      fileUpload: null,
      fileManager: [],
      slice: 3,
      showMore: false,
      isLoading: false,
      selected: null,
      tab: 'upload',
    };
  },
  props: {
    name: {
      type: String,
      default: 'Upload',
    },
    showUploadDialog: Boolean,
    uploadDialog: Function,
    closeDialog: Function,
    type: {
      default: 'all',
    },
  },
  created() {
    if (!this.isInitialize) {
      this.fetchImages();
    }
  },

  computed: {
    checkFileType() {
      if (this.type == 'all') {
        return this.fileTypes.all;
      }
      if (this.type.includes('image') && this.type.includes('video')) {
        return this.fileTypes.media;
      }
      if (this.type.includes('image')) {
        return this.fileTypes.image;
      }
      if (this.type.includes('video')) {
        return this.fileTypes.video;
      }
    },
    files() {
      return this.$store.state.files.files;
    },
    images() {
      return this.$store.state.files.images;
    },
    videos() {
      return this.$store.state.files.videos;
    },
    isInitialize() {
      {
        return this.$store.state.files.isInitialized;
      }
    },
  },

  methods: {
    fetchImages() {
      this.isLoading = true;
      this.$store.dispatch('files/setIntialize', true);
      this.axios
        .get('/client/lms/fetch-images', {
          params: {
            type: 'all',
          },
        })
        .then(({ data }) => {
          this.files = data;
          this.$store.dispatch('files/setFiles', data);
          this.$store.dispatch('files/setImages', data);
          this.$store.dispatch('files/setVideos', data);
        })
        .finally((data) => {
          this.isLoading = false;
        });
    },
    store() {
      let tab = this.tab;

      let file = {
        type: '',
        value: null,
      };
      if (tab == 'upload') {
        file.type = tab;
        file.value = this.fileUpload;
      } else if (tab == 'filemanager') {
        file.type = 'url';
        file.value = this.selected.url;
      } else if (tab == 'url') {
        file.type = tab;
        file.value = this.url;
      }
      this.$emit('showImage', file);
      this.close();
    },
    close() {
      this.closeDialog();
      this.showUploadDialog = false;
      this.reset();
    },
    changeSelected(item) {
      this.selected = item;
    },
    changeTab(tab) {
      this.tab = tab;
    },
    reset() {
      this.url = '';
      this.fileUpload = null;
    },
  },
};
</script>
